import React from 'react';

import { connect } from 'react-redux';

import modal from '../definitions/Modal';
import HpaBeginModal from './hpa/HpaBeginModal';
import {
  doExitHpa,
  goToHpa,
  hideHpaBeginModal,
  hideHpaChangeModal,
  hideHpaNotAllowedModal,
} from '../data/hpa/actions';
import { showNavModal, hideNavModal } from '../data/navigation/actions';
import { hideTimelineModal } from '../views/timeline/data/actions';
import HpaChangeModal from './hpa/HpaChangeModal';
import { getName } from '../data/user/profile/selectors';
import HpaNotAllowedModal from './hpa/HpaNotAllowedModal';
import SessionUtils from '../utils/SessionUtils';
import GTIBeginModal from '../views/timeline/components/gti/GTIBeginModal';
import {
  goToGTI,
  hideGtiBeginModal,
  showGtiBeginModal,
} from '../data/service/gti/actions';
import NavigationModal from './navigation/NavigationModal';
import NavigateToQuestionnaireModal from './questionnaire/omavointi/NavigateToQuestionnaireModal';
import { QUESTIONNAIRES, TIMELINE } from '../data/reducer';
import {
  goToOmavointi,
  hideOmavointiQuestionnaireModal,
} from '../data/questionnaires/actions';
import TimelineTopAlertModal from '../views/timeline/components/TimelineTopAlertModal';

const notificationModal = modal({ content: { width: '500px' } });

const ModalStack = ({
  hpaNotAllowedModalIsVisible,
  hideHpaNotAllowedModal,
  hpaName,
  hpaBeginModalIsVisible,
  hideHpaBeginModal,
  hpaChangeModalIsVisible,
  hideHpaChangeModal,
  goToHpa,
  exitHpaAndReload,
  exitHpaWithoutReload,
  gtiHideModal,
  gtiBeginModalIsVisible,
  goToGTI,
  gtiFetching,
  navigationModalIsVisible,
  hideNavModal,
  navigationModalData,
  navigationIsExternal,
  hideNavigateToQuestionnaireModal,
  navigateToQuestionnaireModalData,
  goToOmavointi,
  hideTimelineModal,
  timelineModalIsVisible,
}) => (
  <>
    <HpaBeginModal
      isOpen={hpaBeginModalIsVisible}
      hideModal={hideHpaBeginModal}
      goToHpa={goToHpa}
    />
    <HpaChangeModal
      name={hpaName}
      isOpen={hpaChangeModalIsVisible}
      hideModal={hideHpaChangeModal}
      goToHpa={goToHpa}
      exitHpa={exitHpaAndReload}
    />
    <HpaNotAllowedModal
      isOpen={hpaNotAllowedModalIsVisible}
      exitHpa={() => {
        exitHpaWithoutReload(false);
        hideHpaNotAllowedModal();
      }}
      logout={() => SessionUtils.logout()}
    />
    <GTIBeginModal
      isOpen={gtiBeginModalIsVisible}
      goToGTI={goToGTI}
      hideModal={gtiHideModal}
      gtiFetching={gtiFetching}
    />
    <NavigationModal
      isOpen={navigationModalIsVisible}
      hideModal={hideNavModal}
      data={navigationModalData}
      isExternal={navigationIsExternal}
    />
    <NavigateToQuestionnaireModal
      isOpen={navigateToQuestionnaireModalData.show}
      goToOmavointi={goToOmavointi}
      hideModal={hideNavigateToQuestionnaireModal}
      data={navigateToQuestionnaireModalData}
    />
    <TimelineTopAlertModal
      isOpen={timelineModalIsVisible}
      hideModal={hideTimelineModal}
    />
  </>
);

const mapStateToProps = (state) => {
  return {
    hpaBeginModalIsVisible: state.hpa.hpaBeginModalIsVisible,
    hpaChangeModalIsVisible: state.hpa.hpaChangeModalIsVisible,
    hpaNotAllowedModalIsVisible: state.hpa.hpaNotAllowedModalIsVisible,
    hpaName: getName(state),
    gtiBeginModalIsVisible: state.services.gti.modalIsVisible,
    gtiFetching: state.services.gti.isFetching,
    navigationModalIsVisible: state.nav.navigationModalIsVisible,
    navigationModalData: state.nav.navigationModalData,
    navigationIsExternal: state.nav.navigationIsExternal,
    navigateToQuestionnaireModalData:
      state[QUESTIONNAIRES].omavointiQuestionnaireModal,
    timelineModalIsVisible: state[TIMELINE].timelineModalIsVisible,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideHpaNotAllowedModal: () => dispatch(hideHpaNotAllowedModal()),
    hideHpaBeginModal: () => dispatch(hideHpaBeginModal()),
    hideHpaChangeModal: () => dispatch(hideHpaChangeModal()),
    goToHpa: () => dispatch(goToHpa()),
    exitHpaAndReload: () => dispatch(doExitHpa(true)),
    exitHpaWithoutReload: () => dispatch(doExitHpa(false)),
    gtiHideModal: () => dispatch(hideGtiBeginModal()),
    goToGTI: () => dispatch(goToGTI()),
    hideNavModal: () => dispatch(hideNavModal()),
    hideNavigateToQuestionnaireModal: () =>
      dispatch(hideOmavointiQuestionnaireModal()),
    goToOmavointi: (...params) => dispatch(goToOmavointi(...params)),
    hideTimelineModal: () => dispatch(hideTimelineModal()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalStack);
